// src/pages/promos/CreatePromoPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "@/layouts/AdminLayout";
import Breadcrumbs from "@/components/shared/nav/Breadcrumbs";
import PromoForm from "@/components/promos/forms/PromoForm";
import { useCreatePromoMutation } from "@/api/features/promos";
import type { CreatePromoPayload, UpdatePromoPayload } from "@/api/features/promos";

export default function CreatePromoPage() {
  const navigate = useNavigate();
  const createMut = useCreatePromoMutation();
  const [error, setError] = useState<string | null>(null);

  const onSubmit = (payload: CreatePromoPayload | UpdatePromoPayload) => {
    setError(null);
    createMut.mutate(payload as CreatePromoPayload, {
      onSuccess: () => navigate("/promos"),
      onError: (e) => setError(e.message || "Failed to create promo"),
    });
  };

  return (
    <AdminLayout>
      <Breadcrumbs />
      <div className="mb-5">
        <h1 className="text-lg font-semibold text-gray-900">New Promo</h1>
        <p className="text-sm text-gray-500">Create a discount campaign.</p>
      </div>
      <div className="w-full rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <PromoForm
          mode="create"
          submitting={createMut.isPending}
          error={error}
          onCancel={() => navigate("/promos")}
          onSubmit={onSubmit}
        />
      </div>
    </AdminLayout>
  );
}
